import O1HD, {services} from "../../../../engines/gameEngine";
import normalMode from "../../normalMode";
import {GAME_MODE} from "../../../../engines/managers/gameContent/gameMode_json";
import {AccountItem} from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import cooperativeBankPage from "../cooperativePrefab/cooperativeBankPage";
import { UIKind } from "../../../define/UIKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class winPage extends cc.Component {

    @property({type:cc.Node,displayName:"center节点"})
    center:cc.Node = null;

    @property({type:cc.Label,displayName:"标题内容"})
    lbTitle : cc.Label = null;

    @property({type:cc.Node,displayName:"还款Node"})
    repaymentNode : cc.Node = null;
    @property({type:cc.Node,displayName:"描述标题"})
    lbDescTitle : cc.Node = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property({type:cc.Node,displayName:"内容"})
    lbContent : cc.Node = null;

    @property(cc.Node)
    hasPayNode : cc.Node = null;

    @property(cc.Node)
    btnMakeSure : cc.Node = null;

    @property({type:cc.Node,tooltip:"分享按钮节点"})
    btnShare:cc.Node = null;

    gameLayer:normalMode = null;

    bindLayer(Layer:normalMode){
        this.gameLayer = Layer;
    }

    timeIsVaild:boolean = true;

    onLoad(){
        this.timeIsVaild = O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStop();
        this.node.zIndex = 1;
        if(O1HD.getManagers().gameMgr.platName == "novelapp"){
            this.btnShare.active = false;
        }
    }

    protected start(): void {
        // this.center.scale = 0;
        // cc.tween(this.center).to(0.5,{scale:1},{easing:cc.easing.backOut}).start();
        // this.gameLayer.gameManager.pauseTimer();

        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.OREPAYMENT_LAYER);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.OREPAYMENT_LAYER);
    }

    closeThis(complete?:()=>void){
        // cc.tween(this.center).to(0.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            complete && complete();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

    /**
     * 今日还款     确认， 重新挑战，银行贷款
     */
    todayPayment(){
        //呈现内容
        this.lbTitle.string = `今日还款`;

        let getGameData = NormalGameManager._instance.getGameData();
        this.repaymentNode.active = true;
        let needPayMoney : number = 0 ;

        let bNeedSave = false;
        for ( let accountInfo of getGameData.userAccountInfo ) {
            if (accountInfo.needPayDays > (accountInfo.hasPayDays+1) && accountInfo.everyDayPay == 0) {
                continue;
            }
            
            let payMoney = 0;
            if (accountInfo.hasPayDays >= (accountInfo.needPayDays-1)) {
                payMoney = (accountInfo.totalFee - accountInfo.everyDayPay * (accountInfo.needPayDays-1));
            } else {
                payMoney = accountInfo.everyDayPay;
            }
            needPayMoney += payMoney;
            // needPayMoney += Math.floor( accountInfo.totalFee / accountInfo.needPayDays );
            let contentDesc = cc.instantiate( this.lbContent );
            contentDesc.active = true;
            contentDesc.getComponent(cc.Label).string = `${accountInfo.title}:${payMoney}`;
            this.contentNode.addChild( contentDesc );
        }
        this.lbDescTitle.getChildByName("lbAllAccount").getComponent(cc.Label).string = `（总计 ${needPayMoney}）`;
        //判断成功,失败
        if ( O1HD.getServices().userSrv.getCoins() >= needPayMoney ){
            //减去金额
            O1HD.getServices().userSrv.setCoins( -needPayMoney , true );
            // 添加游戏账户 明细记录
            for ( let i = 0 ; i < getGameData.userAccountInfo.length ; i ++ ) {
                let accountInfo = getGameData.userAccountInfo[i];
                if (accountInfo.everyDayPay == 0 && accountInfo.needPayDays > (accountInfo.hasPayDays+1)) {
                    continue;
                }
                accountInfo.hasPayDays ++;
                if ( accountInfo.hasPayDays >= accountInfo.needPayDays ) {
                    NormalGameManager._instance.payOffTheCreditDispose(accountInfo);
                    //如果已经还清
                    getGameData.userAccountInfo.splice( i , 1);
                    i --;
                }
            }
            if (getGameData.userAccountInfo.length <= 0 && getGameData.userAccountInfoNewMsg == 1) {
                getGameData.userAccountInfoNewMsg = 0;
            }
            bNeedSave = true;
            // NormalGameManager._instance.writeGameData();
            //成功
            this.hasPayNode.active = true;
            this.btnMakeSure.active = true;
        }

        if (bNeedSave) {
            NormalGameManager._instance.writeGameData();
        }
    }

    /**
     *
     */
    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        // this.gameLayer.gameManager.resumeTimer();
        this.closeThis();
    }

    /**
     *
     */
    onBtnShare(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        services().miniGameSrv.getAppApiInstance().shareGameRecordVideo(() => {
            // this.shareBtn.node.active = false;;
        },(e)=>{
            if(!this.timeIsVaild){
                O1HD.getModules().uiControlModule.showMessageBox("录屏小于3秒，分享失败");
                return;
            };
            O1HD.getModules().uiControlModule.showMessageBox("分享失败",this.node );
        });
    }

    update(dt: number): void {
        NormalGameManager._instance.pauseTimer();
    }

    onDisable(): void {
        NormalGameManager._instance.resumeTimer();
        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStart({duration:60});
    }

}
